import { render, staticRenderFns } from "./deliveryComponent.vue?vue&type=template&id=47693520"
import script from "./deliveryComponent.vue?vue&type=script&lang=js"
export * from "./deliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiCheckoutInfoSummary: require('/home/node/app/components/ui/checkout/infoSummary.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerShipping: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/checkout/ControllerShipping.js').default})
